import React, { useEffect, useState } from 'react';
import { Dropdown, Spinner } from 'react-bootstrap';
import { useCookies } from "react-cookie";
import { LogOut, Search } from 'react-feather';
import { Trans } from 'react-i18next';
import { toast } from 'react-toastify';
import { logout } from '../utils/APIs';
import { getSender } from '../utils/config/ChatLogics';
import { ChatState } from '../utils/Context/ChatProvider';
import CommandPalette from './CommandPalette';

const Navbar = () => {
  const [, , removeCookie] = useCookies();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [isPaletteOpen, setIsPaletteOpen] = useState(false);
  const {
    notification,
    setNotification,
    setSelectedChat,
    user
  } = ChatState();

  const toggleOffcanvas = () => {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }

  // Global Cmd+K / Ctrl+K opens the command palette
  useEffect(() => {
    const handler = (e) => {
      const isCmdK = (e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K');
      if (isCmdK) {
        e.preventDefault();
        setIsPaletteOpen((open) => !open);
      } else if (e.key === '/' && !isPaletteOpen) {
        const tag = (e.target && e.target.tagName) || '';
        const isEditing = ['INPUT', 'TEXTAREA', 'SELECT'].includes(tag) || (e.target && e.target.isContentEditable);
        if (!isEditing) {
          e.preventDefault();
          setIsPaletteOpen(true);
        }
      }
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [isPaletteOpen]);

  const signOut = async () => {
    if (isLoggingOut) return; // Prevent multiple clicks
    
    setIsLoggingOut(true);
    toast.info('Logging out...', { autoClose: 1000 });
    
    // Don't save URL on manual logout - user intentionally left the page
    // URL is only saved on session expiry (401) in axios interceptor
    sessionStorage.removeItem('redirectAfterLogin');
    sessionStorage.removeItem('redirectAttempts');
    sessionStorage.removeItem('lastAttemptedRedirect');
    
    try {
      await logout();
      setTimeout(() => {
        removeCookie('user', { path: '/' });
        toast.success('Logged out successfully', { autoClose: 2000 });
      }, 100);
    } catch (error) {
      setIsLoggingOut(false);
      toast.error('Logout failed. Please try again.');
    }
  }

  return (
    <nav className="navbar col-lg-12 col-12 p-lg-0 fixed-top d-flex flex-row">
      <div className="navbar-menu-wrapper d-flex align-items-center justify-content-between">
        <a
          className="navbar-brand brand-logo-mini align-self-center d-lg-none"
          href="/dashboard"
          onClick={evt => evt.preventDefault()}
        >
          <img
            src={require("../../assets/images/logo/starn22_logo.png")}
            alt="logo"
          />
          <span className="brand-text">Starn22</span>
        </a>
        <button className="navbar-toggler navbar-toggler align-self-center" type="button" onClick={() => document.body.classList.toggle('sidebar-icon-only')}>
          <i className="mdi mdi-menu"></i>
        </button>
        <button
          type="button"
          className="navbar-search-trigger ml-auto"
          onClick={() => setIsPaletteOpen(true)}
          aria-label="Search pages"
          title="Search (Ctrl/Cmd + K)"
        >
          <Search size={16} />
          <span className="placeholder">Search pages…</span>
          <kbd className="d-none d-md-inline">⌘K</kbd>
        </button>
        <ul className="navbar-nav navbar-nav-right">
          <li className="nav-item  nav-profile border-0 pl-4">
            <Dropdown>
              <Dropdown.Toggle className="nav-link count-indicator p-0 toggle-arrow-hide bg-transparent">
                <i className="mdi mdi-bell-outline"></i>
                <span className="count bg-success">{notification.length}</span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="navbar-dropdown preview-list">
                {!notification.length && <Dropdown.Item className="dropdown-item py-3 d-flex align-items-center" href="!#" onClick={evt => evt.preventDefault()}>
                  <p className="mb-0 font-weight-medium float-left"><Trans>{!notification.length ? "No New Messages" : `${notification.length} new notifications`}</Trans> </p>
                </Dropdown.Item>}
                <div className="dropdown-divider"></div>
                {
                  notification?.map((notif) => {
                    return (
                      <Dropdown.Item className="dropdown-item py-3 d-flex align-items-center" href="!#" onClick={(evt) => {
                        evt.preventDefault()
                        setSelectedChat(notif.chat_data);
                        setNotification(notification.filter((n) => n !== notif));
                      }}>
                        <p className="mb-0 font-weight-medium float-left">
                          <Trans>
                            {notif.chat_data.isGroupChat === 1
                              ? `New Message in ${notif.chat_data.chatName}`
                              : `New Message from ${getSender(user, notif.users)}`}
                          </Trans> </p>
                      </Dropdown.Item>
                    )
                  })
                }
              </Dropdown.Menu>
            </Dropdown>
          </li>

          <li className="nav-item  nav-profile border-0">
            {isLoggingOut ? (
              <Spinner 
                animation="border" 
                size="sm" 
                variant="primary"
                style={{ cursor: 'not-allowed' }}
              />
            ) : (
              <LogOut 
                onClick={signOut} 
                className="pointer" 
                style={{ cursor: 'pointer' }}
                title="Logout"
              />
            )}
          </li>
        </ul>
        <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" onClick={toggleOffcanvas}>
          <span className="mdi mdi-menu"></span>
        </button>
      </div>
      <CommandPalette show={isPaletteOpen} onClose={() => setIsPaletteOpen(false)} />
    </nav>
  )
}

export default Navbar